// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiKey: "AIzaSyDiXK3Y00ys0fk9aacKAqbcMrc-v_gcbB8",
  authDomain: "hakaya-11349.firebaseapp.com",
  databaseURL: "https://hakaya-11349-default-rtdb.firebaseio.com",
  projectId: "hakaya-11349",
  storageBucket: "hakaya-11349.appspot.com",
  messagingSenderId: "107217497384",
  appId: "1:107217497384:web:0326815ea3434138d0341d",
  measurementId: "G-2T6D7M73EF"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
